module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan3-2-bc13c6eb5f1c7b5dee30cfcb0aa260ec.webp";